import { BASE_FRONT_END_URL } from "../../../../utils/appConstant";

function ExclusiveContentCitations({ citation, onCitationClick }: any) {
    function onCitationClicked(citations: any): void {
        if (onCitationClick) {
            onCitationClick(citations);
        }
    }
    return (
        <div>
            <a
                target="_blank"
                rel="noopener noreferrer"
                href={BASE_FRONT_END_URL + "my-exclusive-content/published/" + citation.citation.substring(0, citation.citation.lastIndexOf("."))}
                className="cursor-pointer text-blue-600 hover:underline"
            >
                {citation.title} <i> by {citation.author} </i>
            </a>
        </div>
    );
}

export default ExclusiveContentCitations;
